module.exports = __webpack_public_path__ + "img/pg.10b9efc1.svg";